export default __webpack_public_path__ + "static/media/image.crimson-laboratories-pvt-ltd.db15d17e.png";